const initialstate = {
  data:[],
  drepdata:[],
  
}

const OrgDonorReportsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_dreport_data_success':
          return {... state, drepdata:action.payload};
                     default :
          return state;
  }
};
export default OrgDonorReportsReducers;